/*
  Towel add-on (snippets/towel-addon.liquid).
  - Single-select toggle tiles (aria-pressed); tapping the selected tile clears it.
  - "+N more" reveals the rest inline; "Show fewer" collapses.
  - Adds through /cart/add.js with a hidden _upsell_source line property, then hands the
    re-rendered cart sections to the theme's xoStore so the drawer / cart page refresh themselves.
  - PDP: picking reveals "Add bag + towel", which adds both in one request and opens the drawer.
    The pick is kept in sessionStorage, so it survives colourway soft-swaps (the whole section is
    re-rendered) and shows as "Your pick" in the drawer if the shopper used the main Add to cart.
  - Tracking: Clarity events (towel_addon_view / _more / _select / _add / _error) plus a Shopify
    customer event 'towel_addon' that a custom pixel can forward to GA4. Page-level gtag() isn't
    used because no Google tag runs on the page (GA4 comes through Shopify's sandboxed pixel).
    Orders carry _upsell_source on the towel line, which is the source of truth for attach rate.
*/
(function () {
  if (customElements.get('towel-addon')) return;

  var PICK_KEY = 'linkslite:towel-pick';
  var PICK_TTL = 30 * 60 * 1000; // a PDP pick only carries into the drawer for 30 minutes
  var MSG_SOLD_OUT = 'That design is sold out. Pick another one.';
  var MSG_GENERIC = "Couldn’t add the towel. Try again.";
  var MSG_BAG_SOLD_OUT = 'That colourway just sold out. Try another one.';

  function readPick() {
    try {
      var pick = JSON.parse(sessionStorage.getItem(PICK_KEY) || 'null');
      if (pick && pick.ts && Date.now() - pick.ts < PICK_TTL) return pick;
      sessionStorage.removeItem(PICK_KEY);
    } catch (e) {}
    return null;
  }
  function savePick(tile) {
    try {
      pagePick = tile ? tile.dataset.variant : null;
      if (tile) sessionStorage.setItem(PICK_KEY, JSON.stringify({ variant: tile.dataset.variant, name: tile.dataset.name, ts: Date.now() }));
      else sessionStorage.removeItem(PICK_KEY);
    } catch (e) {}
  }

  // One live region that survives drawer re-renders, so "added" is still announced.
  function announce(text) {
    var el = document.getElementById('towel-addon-live');
    if (!el) {
      el = document.createElement('p');
      el.id = 'towel-addon-live';
      el.setAttribute('aria-live', 'polite');
      el.style.cssText = 'position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap;margin:0';
      document.body.appendChild(el);
    }
    el.textContent = '';
    setTimeout(function () { el.textContent = text; }, 50);
  }

  // PDP picks only carry across colourway soft-swaps on the same page (a page-lifetime variable),
  // never into another bag's PDP opened as a new page. The drawer still reads sessionStorage.
  var pagePick = null;

  var viewed = {};
  function track(action, placement, design) {
    var data = { action: action, placement: placement };
    if (design) data.design = design;
    try {
      if (typeof window.clarity === 'function') {
        window.clarity('event', 'towel_addon_' + action);
        window.clarity('set', 'towel_addon_' + placement, action);
      }
    } catch (e) {}
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish('towel_addon', data);
      }
    } catch (e) {}
  }

  function sectionIds() {
    var ids = [];
    var cartEl = document.querySelector('xo-cart');
    var miniEl = document.querySelector('xo-cart-mini');
    if (cartEl && cartEl.id) ids.push(cartEl.id);
    if (miniEl && miniEl.id) ids.push(miniEl.id);
    return ids;
  }

  class TowelAddon extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.placement = this.dataset.placement || 'drawer';
      this.grid = this.querySelector('.tw__grid');
      this.cta = this.querySelector('.tw__cta');
      this.pickEl = this.querySelector('.tw__pick');
      this.errEl = this.querySelector('.tw__err');
      this.isPdp = this.placement === 'pdp';
      this.reveal = this.querySelector('.tw__reveal');
      this.caption = this.querySelector('.tw__caption');
      this.moreBtn = this.querySelector('.tw__more');
      this.lessBtn = this.querySelector('.tw__less');
      this.selected = null;
      this.remembered = false;
      this.addEventListener('click', this.onClick.bind(this));
      this.applyRemembered();
      this.watchView();
      if (this.isPdp) this.watchCart();
    }

    // PDP only: the card isn't part of the cart re-render, so follow the cart ourselves.
    // - this bag already in the cart -> button adds the towel only ("Add towel")
    // - any towel in the cart       -> hide the card; show it again if the towel is removed
    watchCart() {
      var self = this;
      this.bagInCart = this.dataset.bagInCart === 'true';
      this.towelVariants = this.tiles().map(function (t) { return t.dataset.variant; });
      if (!window.xoStore || typeof window.xoStore.subscribe !== 'function') return;
      var timer = null;
      this._unsub = window.xoStore.subscribe('xo-cart', function () {
        clearTimeout(timer);
        timer = setTimeout(function () { self.syncCart(); }, 250);
      });
    }

    syncCart() {
      var self = this;
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var ids = (cart.items || []).map(function (i) { return String(i.variant_id); });
          var towelIn = self.towelVariants.some(function (v) { return ids.indexOf(v) > -1; });
          self.bagInCart = ids.indexOf(String(self.dataset.bagVariant)) > -1;
          self.hidden = towelIn;
          if (!towelIn && self.added) {
            // Towel was added here and then removed: come back clean, nothing selected.
            self.added = false;
            self.cta.removeAttribute('aria-disabled');
            self.tiles().forEach(function (t) { t.setAttribute('aria-pressed', 'false'); });
            self.selected = null;
            self.reveal.hidden = true;
          }
          if (self.selected && !self.added) self.setPdpLabel(self.selected);
        })
        .catch(function () {});
    }

    setPdpLabel(tile) {
      var label = this.bagInCart ? 'Add towel \u00b7 ' + tile.dataset.price : this.cta.dataset.labelPrefix + tile.dataset.total;
      this.cta.dataset.label = label;
      if (this.cta.getAttribute('aria-busy') !== 'true') this.cta.textContent = label;
      this.cta.setAttribute('aria-label', this.bagInCart
        ? 'Add towel to cart, ' + tile.dataset.price
        : 'Add bag and towel to cart, ' + tile.dataset.total);
    }

    // One "view" per placement per page load, once at least half the block is on screen.
    // The drawer row is re-created on every cart change, so dedupe by placement, not element.
    watchView() {
      var self = this;
      if (viewed[this.placement] || !('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting && !viewed[self.placement]) {
            viewed[self.placement] = true;
            track('view', self.placement);
            io.disconnect();
          }
        });
      }, { threshold: 0.5 });
      io.observe(this);
      this._io = io;
    }

    disconnectedCallback() {
      if (this._io) this._io.disconnect();
      if (this._unsub) this._unsub();
    }

    tiles() { return Array.prototype.slice.call(this.querySelectorAll('.tw__tile')); }

    applyRemembered() {
      var pick = readPick();
      if (!pick || !pick.variant) return;
      if (this.isPdp && pick.variant !== pagePick) return; // a new page load: don't carry the pick to another bag
      var tile = this.querySelector('.tw__tile[data-variant="' + pick.variant + '"]');
      if (!tile) return;
      // Keep the remembered pick visible while collapsed: swap it into the third slot.
      var li = tile.closest('li');
      if (li.hasAttribute('data-extra') && getComputedStyle(li).display === 'none') {
        var visible = this.grid.querySelectorAll('li:not([data-extra]):not([data-more-li])');
        var third = visible[visible.length - 1];
        if (third) {
          this.grid.insertBefore(li, third);
          li.removeAttribute('data-extra'); li.hidden = false;
          third.setAttribute('data-extra', ''); third.hidden = true;
          this.grid.insertBefore(third, this.grid.querySelector('[data-more-li]'));
        }
      }
      this.remembered = !this.isPdp;
      this.select(tile, true);
    }

    onClick(e) {
      var tile = e.target.closest('.tw__tile');
      if (tile) { this.remembered = false; this.select(tile, false); return; }
      if (e.target.closest('.tw__more')) { this.expand(true); track('more', this.placement); return; }
      if (e.target.closest('.tw__less')) { this.expand(false); return; }
      if (e.target.closest('.tw__cta')) { this.add(); }
    }

    select(tile, silent) {
      var was = tile.getAttribute('aria-pressed') === 'true';
      this.tiles().forEach(function (t) { t.setAttribute('aria-pressed', 'false'); });
      this.hideError();
      if (was && !silent) {
        this.selected = null;
        if (this.isPdp) { this.reveal.hidden = true; savePick(null); }
        else { this.pickEl.hidden = true; this.cta.disabled = true; }
        announce(tile.dataset.name + ' towel deselected.');
        return;
      }
      tile.setAttribute('aria-pressed', 'true');
      this.selected = tile;
      if (this.isPdp) {
        this.caption.textContent = tile.dataset.name + ' \u00b7 ' + tile.dataset.price + ' \u00b7 ships separately';
        if (this.added) { this.added = false; this.cta.removeAttribute('aria-disabled'); }
        this.setPdpLabel(tile);
        this.reveal.hidden = false;
        if (!silent) savePick(tile);
        if (!silent) {
          announce(tile.dataset.name + ' towel selected. Add bag and towel button available.');
          track('select', this.placement, tile.dataset.name);
        }
        return;
      }
      this.pickEl.querySelector('span').textContent = (this.remembered ? 'Your pick: ' : '') + tile.dataset.name;
      this.pickEl.hidden = false;
      this.cta.disabled = false;
      if (!silent) {
        announce(tile.dataset.name + ' towel selected.');
        track('select', this.placement, tile.dataset.name);
      }
    }

    expand(open) {
      var extras = this.grid.querySelectorAll('li[data-extra]');
      // Focus the first print that was actually hidden (desktop already shows some extras).
      var firstNew = null;
      if (open) {
        Array.prototype.forEach.call(extras, function (li) {
          if (!firstNew && getComputedStyle(li).display === 'none') firstNew = li;
        });
      }
      Array.prototype.forEach.call(extras, function (li) { li.hidden = !open; });
      var moreLi = this.grid.querySelector('[data-more-li]');
      if (moreLi) moreLi.hidden = open;
      if (this.lessBtn) this.lessBtn.hidden = !open;
      if (open && (firstNew || extras[0])) (firstNew || extras[0]).querySelector('button').focus();
      if (!open && this.moreBtn) this.moreBtn.focus();
    }

    showError(msg) {
      this.errEl.querySelector('span').textContent = msg;
      this.errEl.hidden = false;
    }

    hideError() { this.errEl.hidden = true; }

    setBusy(busy) {
      // aria-disabled (not disabled) while busy, so a focused button keeps keyboard focus.
      if (busy) {
        this.cta.setAttribute('aria-busy', 'true');
        this.cta.setAttribute('aria-disabled', 'true');
        this.cta.innerHTML = '<span class="tw__spin" aria-hidden="true"></span>Adding…';
      } else {
        this.cta.removeAttribute('aria-busy');
        this.cta.removeAttribute('aria-disabled');
        this.cta.disabled = !this.selected;
        this.cta.textContent = this.cta.dataset.label;
      }
    }

    add() {
      if (!this.selected || this.cta.getAttribute('aria-disabled') === 'true') return;
      var self = this;
      var tile = this.selected;
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var items = [{ id: Number(tile.dataset.variant), quantity: 1, properties: { _upsell_source: this.placement } }];
      var withBag = this.isPdp && !this.bagInCart;
      if (withBag) items.unshift({ id: Number(this.dataset.bagVariant), quantity: 1 });
      var addedQty = items.reduce(function (n, i) { return n + i.quantity; }, 0);
      var cartRoot = document.querySelector(this.placement === 'cart' ? 'xo-cart' : 'xo-cart-mini');
      this.hideError();
      this.setBusy(true);
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({
          items: items,
          sections: sectionIds().join(','),
          sections_url: window.location.pathname
        })
      })
        .then(function (res) {
          return res.json().then(function (data) { return { ok: res.ok, status: res.status, data: data }; });
        })
        .then(function (r) {
          if (!r.ok) {
            var text = ((r.data && (r.data.description || r.data.message)) || '').toLowerCase();
            self.setBusy(false);
            track('error', self.placement, tile.dataset.name);
            var bagTitle = (self.dataset.bagTitle || '').toLowerCase();
            // Shopify's 422 wordings for "no stock left": "...is already sold out.",
            // "You can only add 0 of ... to the cart." Anything else (limits, errors) gets the generic message.
            var soldOut = r.status === 422 && /already sold out|sold out\.|only add 0 /.test(text);
            var bagFailed = withBag && bagTitle && text.indexOf(bagTitle) > -1;
            self.showError(soldOut ? (bagFailed ? MSG_BAG_SOLD_OUT : MSG_SOLD_OUT) : MSG_GENERIC);
            return;
          }
          try { sessionStorage.removeItem(PICK_KEY); } catch (e) {}
          pagePick = null;
          announce(tile.dataset.name + ' towel added to your cart.');
          track('add', self.placement, tile.dataset.name);
          var store = window.xoStore;
          if (store && r.data.sections) {
            // Only size + sections: the drawer / cart page re-render from `sections`; leaving isAdded alone
            // avoids triggering the theme's own post-add effects (fly-to-cart, notifications).
            store.set('xo-cart', function (prev) {
              return Object.assign({}, prev, {
                size: (prev && prev.size ? prev.size : 0) + addedQty,
                sections: Object.assign({}, prev && prev.sections, r.data.sections)
              });
            })('xo-cart/addCartSuccess');
            if (self.isPdp) {
              // Settle the PDP button; watchCart() then hides the card because a towel is in the cart.
              self.added = true;
              self.cta.removeAttribute('aria-busy');
              self.cta.setAttribute('aria-disabled', 'true');
              self.cta.textContent = 'Added';
              if (window.xoModal && typeof window.xoModal.open === 'function') window.xoModal.open('cart');
            } else {
              // This row is being replaced by the re-render; once the new towel line exists,
              // move focus to its title link so keyboard/screen-reader users keep their place.
              var variant = tile.dataset.variant, tries = 0;
              (function focusLine() {
                var links = cartRoot ? cartRoot.querySelectorAll('a[href*="variant=' + variant + '"]') : [];
                var target = links[links.length - 1];
                if (target && document.body.contains(target)) { target.focus(); return; }
                if (++tries < 30) setTimeout(focusLine, 50);
              })();
            }
          } else {
            window.location.reload();
          }
        })
        .catch(function () {
          self.setBusy(false);
          track('error', self.placement, tile.dataset.name);
          self.showError(MSG_GENERIC);
        });
    }
  }

  customElements.define('towel-addon', TowelAddon);
})();
